import type { TermKind } from '@zyx/shared';

/** Every route the app links to, in one place, so a renamed path is one edit. */
export const urls = {
  home: () => '/',
  browse: () => '/browse',
  search: (q: string) => `/browse?q=${encodeURIComponent(q)}`,
  movie: (code: string) => `/movies/${encodeURIComponent(code)}`,
  person: (personId: number) => `/people/${personId}`,
  term: (termId: number) => `/terms/${termId}`,
  terms: (kind: TermKind = 'genre') => `/collections/${kind}`,
  actresses: () => '/collections/actresses',
  watchlist: () => '/watchlist',
  favourites: () => '/favourites',
  hidden: () => '/hidden',
  history: () => '/history',
  lists: () => '/lists',
  list: (listId: number) => `/lists/${listId}`,
  bookmarks: () => '/bookmarks',
  downloads: () => '/downloads',
  stats: () => '/stats',
  /** The movie page, playing a moment of one edition as it opens. */
  movieAt: (code: string, at: { readonly variantId: number; readonly episodeNo: number; readonly positionS: number }) =>
    `/movies/${encodeURIComponent(code)}?variant=${at.variantId}&part=${at.episodeNo}&t=${Math.floor(at.positionS)}`,
  indexing: (tab: 'jobs' | 'rates' = 'jobs') => `/indexing/${tab}`,
  job: (jobId: number) => `/indexing/jobs/${jobId}`,
};
